import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import OpenMasjid from "./plugins/my-kit";

Vue.config.productionTip = false;
Vue.use(OpenMasjid);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
